import styled from "styled-components"

const Input = styled.input`
  width: ${props => props.width || "100%"};
  max-width: 100%;
  padding: 0.4em 0;
  border: 1px solid transparent;
  border-bottom: 1px solid ${props => props.theme.colors.grey20};
  outline: none;

  :focus {
    outline: none;
    border-bottom: 1px solid ${props => props.theme.colors.black};
  }
  ::placeholder {
    color: ${props => props.theme.colors.grey35};
  }
`

export default Input
